export const ResolutionStringEnum = {
  Resolved: 'Resolved',
  Unresolved: 'Unresolved'
};
